module.exports = __webpack_public_path__ + "static/media/2.1656a02a.jpg";